import { Injectable } from '@angular/core';
import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { BotEvent } from '../models/botevent.model';
import { AppConfigService } from '../../shared/appconfig/appconfig.service';
import { AuthService } from '../../auth/auth/auth.service';

@Injectable({
  providedIn: 'root'
})
export class BotEventService {
  private baseUrl: string;
  private headers: HttpHeaders;

  constructor(
    private http: HttpClient,
    private authService: AuthService
  ) {
    this.baseUrl = AppConfigService.settings.get('chatstyleapiServer') + 'botevents';
  }

  /**
   * Get bot events with optional filtering and paging
   */
  getBotEvents(
    botId: string,
    category?: string,
    severity?: string,
    fromDate?: Date | string,
    toDate?: Date | string,
    skip: number = 0,
    take: number = 50,
    channel?: string,
    search?: string
  ): Observable<{ items: BotEvent[], totalCount: number }> {
    this.headers = new HttpHeaders({ 'Authorization': this.authService.getAuthorizationHeaderValue() });

    let params = new HttpParams()
      .set('skip', skip.toString())
      .set('take', take.toString());

    if (category) {
      params = params.set('category', category);
    }
    if (severity) {
      params = params.set('severity', severity);
    }
    if (fromDate) {
      const dateStr = fromDate instanceof Date ? fromDate.toISOString() : fromDate;
      params = params.set('fromDate', dateStr);
    }
    if (toDate) {
      const dateStr = toDate instanceof Date ? toDate.toISOString() : toDate;
      params = params.set('toDate', dateStr);
    }
    if (channel) {
      params = params.set('channel', channel);
    }
    if (search) {
      params = params.set('search', search);
    }

    return this.http.get<{ items: BotEvent[], totalCount: number }>(`${this.baseUrl}/${botId}`, { headers: this.headers, params });
  }

  /**
   * Get available filter options (categories and severities)
   */
  getEventFilters(): Observable<{ categories: string[], severities: string[], channels: string[] }> {
    this.headers = new HttpHeaders({ 'Authorization': this.authService.getAuthorizationHeaderValue() });
    
    return this.http.get<{ categories: string[], severities: string[], channels: string[] }>(`${this.baseUrl}/filters`, { headers: this.headers });
  }

  /**
   * Clear all events for a bot
   */
  clearBotEvents(botId: string): Observable<void> {
    this.headers = new HttpHeaders({ 'Authorization': this.authService.getAuthorizationHeaderValue() });
    
    return this.http.delete<void>(`${this.baseUrl}/${botId}`, { headers: this.headers });
  }
}